module.exports = __webpack_public_path__ + "media/mishina.5708cf8d.mp4";